import { Checkbox, FormControlLabel, Grid } from '@mui/material'
import React from 'react'
import InputFormItem from 'components/Common/ElementInForm/InputFormItem';
import AutoCompleteSelect from 'components/Common/ElementInForm/AutoCompleteSelect';
import AsyncAutoComplete from 'components/Common/ElementInForm/AsyncAutoComplete';
import DatePickerFormItem from 'components/Common/ElementInForm/DatePickerFormItem';
import NativeTimePicker from 'components/Common/ElementInForm/NativeTimePicker';
import AddLocationAltIcon from '@mui/icons-material/AddLocationAlt';
import Typography from '@mui/material/Typography';
import InputCustomLabel from 'components/Common/ElementInForm/InputCustomLabelFormItem';
import moment from 'moment';
import TimePickerFormItem from 'components/Common/ElementInForm/TimePickerFormItem';


const CpnSuggestCustomer = (props) => {
    const {
        form,
        Option,
        sMode,
        onHandleField,
        setIsOpenMap,
        setIsAddAddress,
        IsAddAddress,
        setsLocation,
        setoLocationCurrent,
        setIsSetMap,
        setisInputTelRequireCust,
        nStatusID,
        sVOCFormID,
        lstBA,
        IsAddTelExtentionCust,
        setIsAddTelExtentionCust
    } = props;


    return (
        <>
            <Grid container spacing={2} direction="row" justifyContent="start" alignItems="start" >
                <Grid item xs={12}>
                    <Grid container spacing={2} direction="row" justifyContent="end" alignItems="start" >
                        <Grid item xs={12} sm={3}>
                            <InputFormItem
                                id="sVOCFormCode"
                                name="sVOCFormCode"
                                label="เลขที่ใบแจ้ง"
                                required={false}
                                fullWidth
                                disabled
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <AsyncAutoComplete
                        name="oCustomer"
                        sUrlAPI={"User/SearchUser"}
                        label="ลูกค้า"
                        required={true}
                        textSearch={"กรอกชื่อลูกค้า/นามสกุลลูกค้า"}
                        sMethodAxios={"POST"}
                        onChange={(event) => { onHandleField(event, "Customer") }}
                        disabled={(nStatusID != 0 && sMode === "view") || ([0].includes(nStatusID) && sVOCFormID != "" && sVOCFormID != null)}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    {
                        lstBA != null && lstBA.length > 1 ?
                            <>
                                <InputFormItem
                                    id="sShowBA"
                                    name="sShowBA"
                                    label="กลุ่มตลาด"
                                    required={true}
                                    fullWidth
                                    disabled
                                />
                            </>
                            :
                            <>
                                <AutoCompleteSelect
                                    name="oBA"
                                    options={Option.lstBA ?? []}
                                    label={"กลุ่มตลาด"}
                                    required={true}
                                    disabled={(nStatusID != 0 && sMode === "view") || ([0].includes(nStatusID) && sVOCFormID != "" && sVOCFormID != null) ? true : form.getValues("oCustomer") && form.getValues("oCompany") ? false : true}
                                    onChange={(event) => {
                                        onHandleField(event, "BA");
                                    }}

                                />
                            </>
                    }


                </Grid>
                <Grid item xs={12}>
                    <AutoCompleteSelect
                        name="oCompany"
                        options={Option.lstCompany ?? []}
                        label={"บริษัท"}
                        required={true}
                        onChange={(event) => { onHandleField(event, "Company") }}
                        disabled={(nStatusID != 0 && sMode === "view") || ([0].includes(nStatusID) && sVOCFormID != "" && sVOCFormID != null)}

                    />
                </Grid>
                <Grid item xs={12}>
                    <AutoCompleteSelect
                        name="oAddress"
                        options={Option.lstCompanyAddress ?? []}
                        label={"ที่อยู่/สถานที่เกิดเหตุ"}
                        required={true}
                        disabled={(nStatusID != 0 && sMode === "view") || ([0].includes(nStatusID) && sVOCFormID != "" && sVOCFormID != null)}
                        onChange={(event) => {
                            if (event && event.value === "-1") {
                                setIsAddAddress(true)
                            } else {
                                setIsAddAddress(false)
                                setIsSetMap(false)
                            }
                        }}
                    />
                </Grid>
                <Grid item xs={12} style={{ display: IsAddAddress === true ? 'block' : 'none' }}>
                    <InputCustomLabel
                        id="sAddress"
                        name="sAddress"
                        label="ที่อยู่"
                        required={true}
                        multiline={true}
                        maxLength={1000}
                        disabled={([0].includes(nStatusID) && sVOCFormID != "" && sVOCFormID != null)}
                        rows={2}
                        fullWidth
                        onChange={() => {
                            setIsSetMap(false)
                            setoLocationCurrent({ lat: null, lng: null })
                            setsLocation({
                                Latitude: null,
                                Longitude: null,
                                Address: null,
                            })
                        }}
                    />
                </Grid>
                <Grid item xs={12} style={{ display: IsAddAddress === true ? 'block' : 'none' }}>
                    <Grid container spacing={1} direction="row" justifyContent="start" alignItems="start" >
                        <Grid item>
                            <AddLocationAltIcon style={{ color: '#027db4' }} />
                        </Grid>
                        <Grid item>
                            <div
                                onClick={() => {
                                    setIsOpenMap(true)
                                }}
                                style={{
                                    color: '#027db4',
                                    cursor: 'pointer',
                                    textDecoration: 'underline'
                                }}
                            >
                                <Typography>เลือกจากแผนที่</Typography>
                            </div>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12} sm={form.getValues("oTel") && form.getValues("oTel").value === "-1" ? 12 : 6}>
                    <Grid container spacing={2} direction="row" justifyContent="start" alignItems="start" >
                        <Grid item xs={12} sm={form.getValues("oTel") && form.getValues("oTel").value === "-1" ? 4 : 12}>
                            <AutoCompleteSelect
                                name="oTel"
                                options={Option.lstTel ?? []}
                                label={"หมายเลขโทรศัพท์"}
                                required={true}
                                disabled={nStatusID != 0 && sMode === "view"}
                                onChange={(e) => {
                                    if (e) {
                                        form.clearErrors("sInputTel")
                                        setisInputTelRequireCust(e.value === "-1" ? true : false)
                                    }
                                }}
                            />
                        </Grid>
                        {
                            form.getValues("oTel") && form.getValues("oTel").value === "-1" ?
                                <>
                                    <Grid item xs={12} md={8}>
                                        <Grid container spacing={2} direction="row" justifyContent="start" alignItems="start">
                                            <Grid item xs={12} sm={12} md={6}>
                                                <InputFormItem
                                                    id="sInputTel"
                                                    name="sInputTel"
                                                    label="หมายเลขโทรศัพท์"
                                                    required={true}
                                                    maxLength={10}
                                                    disabled={nStatusID != 0 && sMode === "view"}
                                                    fullWidth
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={12} md={'auto'}>
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            checked={IsAddTelExtentionCust}
                                                            onChange={() => {
                                                                setIsAddTelExtentionCust(!IsAddTelExtentionCust);
                                                                form.setValue("sInputTelExtension", null)
                                                                form.clearErrors("sInputTelExtension")
                                                            }}
                                                        />
                                                    }
                                                    label="เบอร์ต่อ"
                                                    labelPlacement="end"
                                                    disabled={nStatusID != 0 && sMode === "view"}
                                                />
                                            </Grid>
                                            {IsAddTelExtentionCust === true &&
                                                <Grid item xs={12} sm={12} md={4}>
                                                    <InputFormItem
                                                        id="sInputTelExtension"
                                                        name="sInputTelExtension"
                                                        label="เบอร์ต่อ"
                                                        maxLength={10}
                                                        required={true}
                                                        fullWidth
                                                        disabled={nStatusID != 0 && sMode === "view"}
                                                    />
                                                </Grid>
                                            }
                                        </Grid>
                                    </Grid>
                                </>
                                : null
                        }
                    </Grid>
                </Grid>
                <Grid item xs={12} md={6}>
                    <AutoCompleteSelect
                        name="oNoticeChannel"
                        options={Option.lstContactType ?? []}
                        label={"ช่องทางที่รับแจ้ง"}
                        required={true}
                        disabled={nStatusID != 0 && sMode === "view"}
                    />
                </Grid>
                <Grid item xs={12} >
                    <InputCustomLabel
                        id="sDetailSuggestion"
                        name="sDetailSuggestion"
                        label="รายละเอียดข้อแนะนำ"
                        required={true}
                        disabled={nStatusID != 0 && sMode === "view"}
                        multiline={true}
                        maxLength={1000}
                        rows={4}
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <Grid container spacing={2} direction="row" justifyContent="start" alignItems="start" >
                        <Grid item xs={12} sm={6} md={5}>
                            <DatePickerFormItem
                                name="sDateIssue"
                                label="วันที่แจ้ง"
                                disabled={nStatusID != 0 && sMode === "view"}
                                fullWidth={true}
                                required={true}
                                maxDate={moment()}

                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={5}>
                            <TimePickerFormItem
                                name="sTimeIssue"
                                label="เวลาที่แจ้ง"
                                disabled={nStatusID != 0 && sMode === "view"}
                                fullWidth={true}
                                required={true}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12} >
                    <InputCustomLabel
                        id="sNote"
                        name="sNote"
                        label="โน้ต"
                        disabled={nStatusID != 0 && sMode === "view"}
                        required={false}
                        multiline={true}
                        maxLength={1000}
                        rows={4}
                        fullWidth
                    />
                </Grid>
            </Grid>
        </>


    )
}

export default CpnSuggestCustomer